import { render, staticRenderFns } from "./EditModal.vue?vue&type=template&id=72f3f818&"
import script from "./EditModal.vue?vue&type=script&lang=js&"
export * from "./EditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports